export type AuthorItArticleLink = HTMLAnchorElement | HTMLAreaElement;

export function findAuthorItArticleLink(
  event: MouseEvent,
): AuthorItArticleLink | null {
  return (
    event
      .composedPath()
      .find(
        (target): target is AuthorItArticleLink =>
          target instanceof HTMLAnchorElement ||
          target instanceof HTMLAreaElement,
      ) ?? null
  );
}

export const CLICK_RESIZE_IMAGE_CLASS = "clickresizeembeddedjpegfiletemplate";

export function findClickResizeImage(
  event: MouseEvent,
): HTMLImageElement | null {
  return (
    event
      .composedPath()
      .find(
        (target): target is HTMLImageElement =>
          target instanceof HTMLImageElement &&
          target.classList.contains(CLICK_RESIZE_IMAGE_CLASS),
      ) ?? null
  );
}

export function getToggleBlockId(href: string): string {
  const match =
    /^javascript:\s*toggleBlock\(\s*['"]([^'"]+)['"]\s*\)\s*;?$/i.exec(
      href.trim(),
    );
  return match?.[1] ?? "";
}

export const EXPAND_ICON_CLASS = "expandicon";

// Resolve the AuthorIt expanding-block id for a clicked expander link.
// Legacy markup carried the id only in a `javascript:toggleBlock('ID')` href,
// but read-time HTML sanitization strips `javascript:` URLs, so that href is
// gone by render time. Fall back to the surviving `.expandicon` element, whose
// id is `i<ID>` (the toggled block is `d<ID>`). The href is still tried first
// for any unsanitized context.
export function getExpandingBlockId(link: AuthorItArticleLink): string {
  const fromHref = getToggleBlockId(link.getAttribute("href") ?? "");
  if (fromHref) return fromHref;

  const iconId = link.querySelector(`.${EXPAND_ICON_CLASS}`)?.id ?? "";
  const match = /^i(.+)$/.exec(iconId.trim());
  return match?.[1] ?? "";
}

export function getArticleLinkTitle(
  link: AuthorItArticleLink,
  fallback: string,
): string {
  return link.textContent?.trim() || link.title.trim() || fallback;
}
